import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Input, Alert, Spin, message } from "antd";
import { Link, withRouter } from "react-router-dom";
import AuthService from "../services/auth.service";
import IntlMessages from "util/IntlMessages";
import generateCustomCSSGradient from "../util/backgroundSplitByDiagonal";
import { ReactComponent as LawIcon } from "../../src/assets/assets2_0/law_icon.svg";
import { ReactComponent as UserCircleIcon } from "../assets/assets2_0/user_circle.svg";

const FormItem = Form.Item;

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      success: undefined,
      error: undefined,
      loading: false
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          success: undefined,
          error: undefined,
          loading: true
        });

        AuthService.forgotPassword(values)
          .then(response => {
            if (response.status == 200) {
              message.success("Email enviado");

              setTimeout(() => {
                this.redirectToSingIn();
              }, 2000);
            }
          })
          .catch(err => {
            const error = err.response.data.error || "Ha ocurrido un error";
            message.error(error);
          })
          .finally(() => {
            this.setState({
              loading: false
            });
          });
      }
    });
  };

  redirectToSingIn() {
    return this.props.history.push("/");
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div
        className="gx-app-login-wrap"
        style={{
          backgroundImage: generateCustomCSSGradient("#24335D", "#3D529E")
        }}
      >
        <LawIcon className="svg-signin-icon" />
        <div className="sign-in-logo-container">
          <a href="https://metajuridico.com">
            <img
              alt="example"
              width={"340px"}
              height={"100px"}
              src={require("assets/images/header-logo.svg")}
            />
          </a>
        </div>
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                <UserCircleIcon className="user-icon" />
              </div>
              <div className="gx-app-logo-wid">
                <h3>
                  <IntlMessages id="app.userAuth.forgotPassword" />
                </h3>
                <p>
                  <IntlMessages id="app.userAuth.forgot" />
                </p>
              </div>
              <div className="gx-app-logo"></div>
            </div>

            <div className="gx-app-login-content" style={{ width: "75%" }}>
              <Form
                onSubmit={this.handleSubmit}
                className="gx-signin-form gx-form-row0"
              >
                <FormItem>
                  {getFieldDecorator("email", {
                    initialValue: "",
                    rules: [
                      {
                        required: true,
                        type: "email",
                        message: "The input is not valid E-mail!"
                      }
                    ]
                  })(
                    <Input
                      autoComplete="cc-csc"
                      placeholder="Email"
                      className="responsive-input"
                    />
                  )}
                </FormItem>

                <FormItem>
                  {this.state.loading ? (
                    <Spin />
                  ) : (
                    <Button
                      size="large"
                      type="primary"
                      className="gx-mb-0"
                      htmlType="submit"
                    >
                      <IntlMessages id="app.userAuth.reset" />
                    </Button>
                  )}
                  <br />
                  <span>
                    <IntlMessages id="app.userAuth.or" />
                  </span>{" "}
                  <Link to="/signin">
                    <IntlMessages id="app.userAuth.login" />
                  </Link>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalForgotPasswordForm = Form.create()(ForgotPassword);

export default withRouter(WrappedNormalForgotPasswordForm);
